module.exports = __webpack_public_path__ + "static/media/grind-n-noizy.4cb8f98c.jpg";